import React from 'react';

import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const PreviewLinkScreen = (props) => {
    const { buttonContinue, accountLinkingPreviewTitle, accountLinkingPreviewSubTitle } = usePageMessages();
    return (
        <InfoPage
            iconName={'cardp-mastercard-thin'}
            iconColor={'primary'}
            headerText={accountLinkingPreviewTitle}
            secondaryText={accountLinkingPreviewSubTitle}
            primaryButtonCaption={buttonContinue}
            primaryButtonOnClick={props.onClickHandler}
        />
    );
};
export default PreviewLinkScreen;
